/* ============================================
   ROOTINE — Global JS
   Header interactions, drawers, overlays
   ============================================ */

(function () {
  'use strict';

  /* --- Sticky header shadow on scroll --- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastScroll = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 10);
      lastScroll = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Search overlay --- */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');

  function openSearch() {
    searchOverlay.classList.add('active');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }

  function closeSearch() {
    searchOverlay.classList.remove('active');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', openSearch);
    searchClose && searchClose.addEventListener('click', closeSearch);
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  /* --- Mobile drawer --- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const drawerCloseButtons = document.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    mobileDrawer.classList.add('active');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    menuToggle.classList.add('active');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    mobileDrawer.classList.remove('active');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    menuToggle.classList.remove('active');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle && mobileDrawer) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileDrawer.classList.contains('active');
      isOpen ? closeDrawer() : openDrawer();
    });
    drawerCloseButtons.forEach((btn) => btn.addEventListener('click', closeDrawer));
  }

  /* --- Cart drawer --- */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', openCart);
    cartClose && cartClose.addEventListener('click', closeCart);
  }

  /* --- Escape key closes all overlays --- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchOverlay && searchOverlay.classList.contains('active')) closeSearch();
      if (mobileDrawer && mobileDrawer.classList.contains('active')) closeDrawer();
      if (cartDrawer && cartDrawer.classList.contains('active')) closeCart();
    }
  });
})();
